export default "__VITE_ASSET__C2bIZ4g$__"